import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import classNames from 'classnames';
import {modules} from './utils'

const Clipboard = ReactQuill.Quill.import('modules/clipboard');
const Delta = ReactQuill.Quill.import('delta');

class PlainClipboard extends Clipboard {
    onPaste (e) {
        e.preventDefault()
        const range = this.quill.getSelection()
        const text = e.clipboardData.getData('text/plain')
        const delta = new Delta()
        .retain(range.index)
        .delete(range.length)
        .insert(text)
        const index = text.length + range.index
        const length = 0
        this.quill.updateContents(delta, 'silent')
        this.quill.setSelection(index, length, 'silent')
        this.quill.scrollIntoView()
    }
  }

ReactQuill.Quill.register('modules/clipboard', PlainClipboard, true)

class TextEditorField extends Component {
  render() {
    const {input, type, disabled, meta: { touched, error }, placeholder, label, } = this.props;
    
    return (
      <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
        <ReactQuill
            value={input.value}
            onChange={(value) => {
              value = value.replace(/<img[^>]*>/g," ");
              input.onChange(value)
            }}
            
            modules = {modules}
        />
      </div>
    );
  }
}

export default TextEditorField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/TextEditorField.jsx